import { AllocationStatus, AllocationStatusValues } from 'shared/models/enums/AllocationStatus';
import styles from './StatusPill.styles';

const StatusPillSmall: React.FC<{ status: AllocationStatus; text?: string }> = ({ status, text }) => {
  const statusClassMap: Record<AllocationStatus, string> = {
    [AllocationStatus.Active]: 'active',
    [AllocationStatus.Pending]: 'pending',
    [AllocationStatus.Waitlisted]: 'waitlisted',
    [AllocationStatus.Cancelling]: 'cancelling',
    [AllocationStatus.Terminated]: 'terminated'
  };

  return (
    <div css={styles}>
      <div className={`status-pill small ${statusClassMap[status] || ''}`}>
        {text || AllocationStatusValues[status].abbr}
      </div>
    </div>
  );
};

export default StatusPillSmall;
